// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analysis-tab {
  margin-top: 1rem;
}

.analysis-tab .two-cols {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 2rem;
}

.analysis-tab .col-left h3,
.analysis-tab .col-right h3 {
  margin-bottom: 1rem;
  color: #333;
  font-size: 1.1rem;
}

.analysis-tab .template-selector {
  margin-bottom: 1rem;
}

.analysis-tab .template-selector select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background-color: white;
  font-size: 1rem;
}

.search-terms {
  margin-bottom: 1rem;
}

.search-terms label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #555;
}

.search-terms input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 1rem;
}

.analysis-tab textarea {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-family: inherit;
  font-size: 1rem;
  resize: vertical;
  box-sizing: border-box;
  min-height: 180px;
}

.analysis-tab textarea[readonly] {
  background-color: #f8f9fa;
  color: #666;
}

.dafo-status {
  margin: 1rem 0;
}

.status-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  border-radius: 6px;
  border: 1px solid #dee2e6;
}

.status-item.completed {
  background-color: #e3f2fd;
  border-color: #1976d2;
}

.status-item.pending {
  background-color: #f8f9fa;
  color: #666;
}

.status-item .status {
  font-weight: bold;
  font-size: 1.1rem;
}

.status-item.completed .status {
  color: #1976d2;
}

.status-item.pending .status {
  color: #ccc;
}

.dafo-actions {
  margin: 1.5rem 0;
}

.info-box.success {
  background-color: #e8f5e8;
  color: #2e7d32;
  border-left-color: #4caf50;
}

.info-box.warning {
  background-color: #fff3e0;
  color: #f57c00;
  border-left-color: #ff9800;
}

.manual-dafo {
  margin-top: 2rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 6px;
}

.manual-dafo h4 {
  margin-bottom: 1rem;
  color: #333;
  font-size: 1rem;
}

.help-text {
  margin-top: 0.5rem;
  font-size: 0.9rem;
  color: #666;
  line-height: 1.4;
}

.analyze-btn.secondary {
  background-color: #f8f9fa;
  color: #1976d2;
  border: 1px solid #1976d2;
}

.analyze-btn.secondary:hover:not(:disabled) {
  background-color: #e3f2fd;
}

.result-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 0.75rem;
  background-color: #f8f9fa;
  border-radius: 6px;
  font-size: 0.9rem;
  color: #666;
}

.result-meta span {
  font-weight: 500;
}

.export-actions {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
}

.export-btn {
  padding: 0.75rem 1.5rem;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.export-btn:hover {
  background-color: #45a049;
}`, "",{"version":3,"sources":["webpack://./src/components/Point3.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;;EAEE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".analysis-tab {\n  margin-top: 1rem;\n}\n\n.analysis-tab .two-cols {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 2rem;\n}\n\n.analysis-tab .col-left h3,\n.analysis-tab .col-right h3 {\n  margin-bottom: 1rem;\n  color: #333;\n  font-size: 1.1rem;\n}\n\n.analysis-tab .template-selector {\n  margin-bottom: 1rem;\n}\n\n.analysis-tab .template-selector select {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  background-color: white;\n  font-size: 1rem;\n}\n\n.search-terms {\n  margin-bottom: 1rem;\n}\n\n.search-terms label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #555;\n}\n\n.search-terms input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  font-size: 1rem;\n}\n\n.analysis-tab textarea {\n  width: 100%;\n  padding: 0.75rem;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  font-family: inherit;\n  font-size: 1rem;\n  resize: vertical;\n  box-sizing: border-box;\n  min-height: 180px;\n}\n\n.analysis-tab textarea[readonly] {\n  background-color: #f8f9fa;\n  color: #666;\n}\n\n.dafo-status {\n  margin: 1rem 0;\n}\n\n.status-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem;\n  margin-bottom: 0.5rem;\n  border-radius: 6px;\n  border: 1px solid #dee2e6;\n}\n\n.status-item.completed {\n  background-color: #e3f2fd;\n  border-color: #1976d2;\n}\n\n.status-item.pending {\n  background-color: #f8f9fa;\n  color: #666;\n}\n\n.status-item .status {\n  font-weight: bold;\n  font-size: 1.1rem;\n}\n\n.status-item.completed .status {\n  color: #1976d2;\n}\n\n.status-item.pending .status {\n  color: #ccc;\n}\n\n.dafo-actions {\n  margin: 1.5rem 0;\n}\n\n.info-box.success {\n  background-color: #e8f5e8;\n  color: #2e7d32;\n  border-left-color: #4caf50;\n}\n\n.info-box.warning {\n  background-color: #fff3e0;\n  color: #f57c00;\n  border-left-color: #ff9800;\n}\n\n.manual-dafo {\n  margin-top: 2rem;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n}\n\n.manual-dafo h4 {\n  margin-bottom: 1rem;\n  color: #333;\n  font-size: 1rem;\n}\n\n.help-text {\n  margin-top: 0.5rem;\n  font-size: 0.9rem;\n  color: #666;\n  line-height: 1.4;\n}\n\n.analyze-btn.secondary {\n  background-color: #f8f9fa;\n  color: #1976d2;\n  border: 1px solid #1976d2;\n}\n\n.analyze-btn.secondary:hover:not(:disabled) {\n  background-color: #e3f2fd;\n}\n\n.result-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  padding: 0.75rem;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  font-size: 0.9rem;\n  color: #666;\n}\n\n.result-meta span {\n  font-weight: 500;\n}\n\n.export-actions {\n  margin-top: 1rem;\n  display: flex;\n  justify-content: center;\n}\n\n.export-btn {\n  padding: 0.75rem 1.5rem;\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.export-btn:hover {\n  background-color: #45a049;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
